import store from "../redux/store";
import removeNotificationsForTask from "./removeNotificationsForTask";
import { scheduleNotificationsForAllTasks } from "./scheduleNotificationsForAllTasks";
import scheduleEngagementNotifications from "./engagement/scheduleEngagementNotifications";

/**
 * Cancel all existing notifications and re-schedule them based on current preferences.
 * Called when the user saves notification preference changes.
 */
export const rescheduleAllNotifications = async () => {
  try {
    const tasks = store.getState().tasks.taskSet;
    const taskList = Object.values(tasks);

    // Remove all existing task notifications (and their tracking keys)
    for (const task of taskList) {
      await removeNotificationsForTask(task.taskId);
    }

    // Re-schedule task notifications (will now respect preferences)
    await scheduleNotificationsForAllTasks(tasks);

    // Re-schedule engagement notifications (will now respect preferences)
    await scheduleEngagementNotifications();

    console.log("All notifications rescheduled based on updated preferences");
  } catch (error) {
    console.warn("Failed to reschedule notifications:", error.message);
  }
};
